import { NgFor, NgIf } from '@angular/common';
import { Component, input } from '@angular/core';
import { AbstractControl } from '@angular/forms';

/**
 * Exibe as mensagens de validação de um controle de formulário.
 *
 * Para cada erro presente em {@link control}, exibe a mensagem correspondente
 * em {@link messages} (ou a própria chave do erro, se não houver mensagem).
 */
@Component({
    selector: 'ai-control-errors',
    imports: [NgIf, NgFor],
    templateUrl: './control-errors.component.html',
})
export class ControlErrors {
    /** Controle cujo estado de erro será observado (obrigatório). */
    control = input.required<AbstractControl | null>();

    /** Mapa de mensagens por chave de erro de validação. */
    messages = input<Record<string, string>>({});

    /** Chaves de erro atualmente presentes no controle. */
    get errorKeys(): string[] {
        return this.control()?.errors
            ? Object.keys(this.control()?.errors!)
            : [];
    }

    /** Retorna a mensagem configurada para a chave de erro, ou a própria chave. */
    getMessage(key: string): string {
        return this.messages()[key] || `${key}`;
    }
}
